import { create } from "zustand";

interface IMenuStoreState {
  isMenuOpen: boolean;
}

interface IMenuStoreAction {
  toggleMenu: () => void;
  openMenu: () => void;
  closeMenu: () => void;
}

type TMenuStore = IMenuStoreAction & IMenuStoreState;

const initialState: IMenuStoreState = {
  isMenuOpen: false,
};

export const useMenuStore = create<TMenuStore>((set) => ({
  ...initialState,
  toggleMenu: () => {
    set(({ isMenuOpen }) => ({ isMenuOpen: !isMenuOpen }));
  },
  openMenu: () => {
    set(() => ({ isMenuOpen: true }));
  },
  closeMenu: () => {
    set(() => ({ isMenuOpen: false }));
  },
}));
